import http, { encode } from './index';

export const getAccessLogsList = async (company, site, params) =>
  http.get(`/companies/${encode(company)}/sites/${encode(site)}/access-events`, { params });

export const getAccessLogDetail = async (company, site, logId) =>
  http.get(`/companies/${encode(company)}/sites/${encode(site)}/access-events/${encode(logId)}`);
